module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-index-thumbnails-1920x1080-0ada449ba20cc78b4cdc70623c10c4fc.jpg";